import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { CanvasNode, CanvasNodeData } from "../../models/CanvasNode";
import { useFlowStore } from "../../store/FlowStateStore.ts";
import { Environment as environment } from "../../environment.ts";

interface FlowBasicInfo {
    flowId: string;
    name: string;
}

const ConnectFlow: React.FC<any> = (data) => {

    const [flows, setFlows] = useState<FlowBasicInfo[]>([]);
    const [flowBasicInfo, setFlowBasicInfo] = useState<FlowBasicInfo>();
    const { nodes, setNodes, businessId } = useFlowStore();
    const isFirstRunRef = useRef(true);

    useEffect(() => {
        axios.get(`${environment.baseUrl}/business/flows/${businessId}`).then((response) => {
            setFlows(response.data.data || []);
        }).catch((error) => {
            console.log(error);
        })
    }, []);

    useEffect(() => {
        const node = nodes.find((n) => n.data.id === data.nodeId);
        if (node) {
            const content = (node.data as CanvasNodeData).content.find((c) => c.id === data.subNodeId);
            if (content?.data) {
                const d = content.data as Record<string, string>;
                if (d.flowId) {
                    setFlowBasicInfo({ flowId: d.flowId, name: d.flowName || "" });
                }
            }
        }
    }, []);

    const setFlow = (event) => {
        const flowName = flows.filter((flow) => (flow.flowId == event.target.value))[0].name;
        const flowBasicInfoPayload: FlowBasicInfo = { flowId: event.target.value, name: flowName } as FlowBasicInfo;
        setFlowBasicInfo(flowBasicInfoPayload);
    }


    useEffect(() => {
        // Skip the very first run: it fires before the restore effect's setFlowBasicInfo
        // (if any) has flowed through a re-render — persisting here would overwrite a
        // previously saved flow selection with undefined.
        if (isFirstRunRef.current) {
            isFirstRunRef.current = false;
            return;
        }
        if (!flowBasicInfo) return;
        const updatedNodes = nodes.map((node) => {
            if (node.data.id == data.nodeId) {
                return {
                    ...node,
                    data: {
                        ...node.data,
                        content: [...(node.data as CanvasNodeData).content.map((nodeContent) => {
                            if (nodeContent.id == data.subNodeId) {
                                return {
                                    ...nodeContent,
                                    data: {
                                        flowId: flowBasicInfo?.flowId,
                                        flowName: flowBasicInfo?.name
                                    }
                                }
                            }
                            return nodeContent
                        })]
                    }
                }
            }
            return node;
        });
        setNodes([...(updatedNodes as CanvasNode[])]);
    }, [flowBasicInfo]);

    return (
        <div className="node-body">
            <div>
                <span className="font-label">Select media type</span>
                <select value={flowBasicInfo?.flowId} onChange={(event) => setFlow(event)}>
                    {
                        flows.map((flow) => {
                            return (
                                <option value={flow.flowId}>{flow.name}</option>
                            )
                        })}
                </select>
            </div>
        </div>
    )
}

export default ConnectFlow;
